import {
    SearchBucket,
    SearchFacet,
    SearchResultProduct,
    SearchResultSuggestion,
    SearchResultUnit
} from '@adobe/magento-storefront-events-sdk/dist/types/types/schemas'

import { ProductSearchResponse } from '../types/interface'
import { Maybe } from '@pylot-data/pylotschema'

export const updateSearchResultsCtx = (
    searchUnitId: string,
    searchRequestId: string,
    // results: ProductSearchResponse['data']['productSearch'],
    results: any,
    pageSize: Maybe<number> | undefined
): void => {
    let mse

    if (typeof window !== 'undefined') {
        mse = window.magentoStorefrontEvents
    }

    if (!mse) {
        // don't break search if events are broken/not loading
        return
    }

    const searchResultsCtx = mse.context.getSearchResults() ?? { units: [] }

    // find search result unit index
    const searchResultUnitIndex = searchResultsCtx.units.findIndex(
        (unit) => unit.searchUnitId === searchUnitId
    )

    // create search result unit
    const searchResultUnit: SearchResultUnit = {
        searchUnitId,
        searchRequestId,
        products: createProducts(results.items),
        categories: [],
        // suggestions: createSuggestions(results.suggestions),
        suggestions: [],
        page: results?.page_info?.current_page || 1,
        perPage: pageSize || 20,
        // facets: createFacets(results.facets)
        facets: []
    }

    // Expose the real total_count so synonym discovery can detect true zero-result searches
    // (products only holds the current page). Extra field, ignored by the SDK's own consumers.
    ;(searchResultUnit as any).totalCount =
        results?.total_count ?? results?.items?.length ?? 0

    // update search result unit
    if (searchResultUnitIndex < 0) {
        searchResultsCtx.units.push(searchResultUnit)
    } else {
        searchResultsCtx.units[searchResultUnitIndex] = searchResultUnit
    }

    mse.context.setSearchResults(searchResultsCtx)
}

const createProducts = (items: any[]): SearchResultProduct[] => {
    if (!items) {
        return []
    }

    const products: SearchResultProduct[] = items.map((item, index) => ({
        name: item?.name,
        sku: item?.sku,
        url: item?.canonical_url ?? '',
        imageUrl: item?.small_image?.url ? (item?.small_image?.url ?? '') : '',
        price:
            item?.price_range?.minimum_price?.final_price?.value &&
            item?.price_range?.minimum_price?.final_price?.value,
        rank: index
    }))

    return products
}

export const createSuggestions = (
    items: ProductSearchResponse['data']['productSearch']['suggestions']
): SearchResultSuggestion[] => {
    if (!items) {
        return []
    }

    const suggestions: SearchResultSuggestion[] = items.map(
        (suggestion, index) => ({
            suggestion,
            rank: index
        })
    )

    return suggestions
}

export const createFacets = (
    items: ProductSearchResponse['data']['productSearch']['facets'] | undefined
): SearchFacet[] => {
    if (!items) {
        return []
    }

    const facets = items.map<SearchFacet>((item) => ({
        attribute: item?.attribute,
        title: item?.title,
        type: item?.type || 'PINNED',
        buckets: item?.buckets.map<SearchBucket>((bucket) => bucket)
    }))

    return facets
}
